import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

// Hook to track page views automatically
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    trackPageView(location.pathname + location.search);
  }, [location]);
};

// Hook for tracking user interactions
export const useAnalytics = () => {
  return {
    trackPageView,
    // Re-export all tracking functions for easy access
    ...require('../utils/analytics')
  };
};